import { Component, ContentChild, Inject, Input } from "@angular/core";
import { TableComponent } from "src/app/components/ui/table/table.component";
import { TemplateDirective } from "src/app/modules/bootstrap/directives/common/template.directive";

@Component({
  selector: "snt-table-column",
  template: "",
  standalone: false
})
export class TableColumnComponent<T> {
  constructor(@Inject(TableComponent) public sntTable: TableComponent<T>) {}

  @Input({ required: true })
  name!: string;

  @Input()
  caption?: string;

  @Input()
  alignCaption?: "start" | "center" | "end";

  @Input()
  expand?: boolean;

  @Input()
  cssClass: string = "";

  @Input()
  valueExpr?: keyof T;

  @Input()
  padding: "0" | "1" | "2" = "2";

  @Input()
  width?: number;

  @ContentChild(TemplateDirective)
  template?: TemplateDirective;
}
